// Below md the steps list is a native scroller: prev/next buttons, and the step in view takes the highlight.
document.querySelectorAll<HTMLElement>('.steps').forEach((section) => {
	const list = section.querySelector<HTMLElement>('.steps__list');
	const prev = section.querySelector<HTMLButtonElement>('[data-steps="prev"]');
	const next = section.querySelector<HTMLButtonElement>('[data-steps="next"]');
	if (!list || !prev || !next) return;
	const items = Array.from(list.querySelectorAll<HTMLElement>('.steps__item'));

	const step = () => {
		const gap = parseFloat(getComputedStyle(list).columnGap) || 0;
		return items[0] ? items[0].offsetWidth + gap : list.clientWidth;
	};

	const update = () => {
		const max = list.scrollWidth - list.clientWidth - 1;
		const scrolling = max > 0;
		list.classList.toggle('is-carousel', scrolling);
		prev.disabled = list.scrollLeft <= 0;
		next.disabled = list.scrollLeft >= max;

		const current = list.scrollLeft >= max ? items.length - 1 : Math.round(list.scrollLeft / step());
		items.forEach((item, i) => item.classList.toggle('is-current', scrolling && i === current));
	};

	prev.addEventListener('click', () => list.scrollBy({ left: -step(), behavior: 'smooth' }));
	next.addEventListener('click', () => list.scrollBy({ left: step(), behavior: 'smooth' }));
	list.addEventListener('scroll', update, { passive: true });
	window.addEventListener('resize', update);
	update();
});
